import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import MedicalRecordForm from 'components/organisms/forms/MedicalRecordForm'

import { crudActionsMap } from 'utils/helpers'
import { useGET_userQuery } from 'redux/api/userAPI'

const MedicalRecordCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const user = useSelector((state: RootState) => state['user'].user)

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete' || user?.role === 'special_teacher'

  return (
    <>
      <PageHeading title={`${t('common.medical-records')} / ${t('common.' + action)}`} />
      <PageBody>
        <MedicalRecordForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default MedicalRecordCrudPage
